if(!customElements.get('language-switch')) {
  // Target true if english is selected, false if turkish is selected
  class LanguageSwitch extends HTMLElement {
    constructor() {
      super();
      this.languageSwitch = this.querySelector('input[name="language-toggle"]');
      this.changer = this.querySelector('input[name="language_code"]');
      this.form = this.querySelector('form');
    }
    connectedCallback() {
      this.languageSwitch.addEventListener('change', (e)=>{ 
        if (e.target.checked) {
          this.changer.value = 'en';
        } else {
          this.changer.value = 'tr';
        }
        this.form.submit();
      });
    }
  }
  customElements.define('language-switch', LanguageSwitch);
}